import React from "react";
import { AccessTimeOutlined, HourglassEmptyOutlined, MonetizationOnOutlined, LocalOfferOutlined } from "@mui/icons-material";

import { CardLayout, OverviewCard } from "../v3";

export const SubcontractorOverview = () => {
  return (
    <>
      <CardLayout
        sx={{
          position: "absolute",
          bottom: "-20px",
          left: "0px",
          right: "0px",
          padding: "0px",
          display: "grid",
          gridTemplateColumns: "repeat(4, 1fr)",
          gap: "12px",
        }}
      >
        <OverviewCard
          title="Actual Hours"
          value="1550"
          extraValue="650"
          extraColor="#18DA4E"
          icon={<AccessTimeOutlined sx={{ fontSize: "1rem", color: "#783DC4" }} />}
        />
        <OverviewCard
          title="Estimated Hours"
          value="2200"
          icon={<HourglassEmptyOutlined sx={{ fontSize: "1rem", color: "#783DC4" }} />}
        />
        <OverviewCard
          title="Actual Cost"
          value="$169,210"
          extraValue="$125,000"
          extraColor="#18DA4E"
          icon={<MonetizationOnOutlined sx={{ fontSize: "1rem", color: "#783DC4" }} />}
        />
        <OverviewCard
          title="Estimated Cost"
          value="$294,210"
          icon={<LocalOfferOutlined sx={{ fontSize: "1rem", color: "#783DC4" }} />}
        />
      </CardLayout>
    </>
  );
};
